import * as React from 'react';
import Chip from '../Chip/Chip';
import cn from '~modules/cn';
import CloseIcon from '../../../assets/icons/v2design/basics/close.svg';
import './tokens.scss';

export type Token = {
    title?: string;
    icon?: React.ReactNode;
};

type Props = {
    values: Token[];
    max?: number;
    disabled?: boolean;
    onRemove?: (index: number) => void;
};

const Tokens = ({ values, disabled, onRemove, max = 2 }: Props) => {
    const renderValues = values.slice(0, max);
    const remainingValues = values.slice(max);
    const result = renderValues.map((value, index) => (
        <Chip
            key={value.title ?? index}
            text={value.title && <span>{value.title}</span>}
            type="primary"
            startIcon={value.icon}
            className={cn('tokens-input-token', { 'tokens-input-token--disabled': disabled })}
            endIcon={
                !disabled && (
                    <div
                        className="tokens-input-token-clear"
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove?.(index);
                        }}
                    >
                        <CloseIcon />
                    </div>
                )
            }
        />
    ));
    if (remainingValues.length) {
        result.push(<Chip key="more" text={`+${remainingValues.length}`} type="primary" />);
    }
    return <>{result}</>;
};

export default Tokens;
